import { NgModule } from '@angular/core';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';

import { AuthService } from './auth.service';
import { AuthInterceptor } from './auth.interceptor';
import { HelpersModule } from '../core/helpers/helpers.module';

@NgModule({
  imports: [HelpersModule, HttpClientModule],
  providers: [
    AuthService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
    // { provide: 'ACCESS_TOKEN', useValue: '' },
  ],
})
export class AuthModule {}
